const updaterequest = {
	name: 'Änderungsanfragen',
	icon: 'fas fa-user-edit',
	fields: {},
}
export default updaterequest
